(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.dataset.end).getTime();
      if (Number.isNaN(this.end)) return;
      this.fields = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = Math.floor((this.end - Date.now()) / 1000);
      if (remaining <= 0) {
        clearInterval(this.timer);
        this.hidden = true;
        return;
      }
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const pad = (n) => String(n).padStart(2, '0');
      if (this.fields.days.textContent !== pad(days)) this.fields.days.textContent = pad(days);
      if (this.fields.hours.textContent !== pad(hours)) this.fields.hours.textContent = pad(hours);
      if (this.fields.minutes.textContent !== pad(minutes)) this.fields.minutes.textContent = pad(minutes);
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-gallery-stage]');
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      this.thumbnails = [...this.querySelectorAll('[data-gallery-thumbnail]')];
      this.thumbnails.forEach((thumb) => thumb.addEventListener('click', () => this.show(thumb.dataset.mediaId)));
      this.stage?.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
      this.section = this.closest('[data-product-section]') || document;
      this.section.addEventListener('variant:changed', (event) => {
        const mediaId = event.detail?.variant?.featured_media?.id;
        if (mediaId) this.show(String(mediaId));
      });
    }

    show(mediaId) {
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      if (index === -1) return;
      this.stage.scrollTo({ left: index * this.stage.clientWidth, behavior: 'smooth' });
      this.activate(index);
    }

    syncFromScroll() {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        const index = Math.round(this.stage.scrollLeft / this.stage.clientWidth);
        this.activate(index);
      }, 80);
    }

    activate(index) {
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-rating"] && !Shopify.designMode) return;
  try {
    // The Judge.me badge only makes its stars clickable; the count next to them follows the
  // same action (the widget scrolls to its reviews).
  document.addEventListener('click', (event) => {
    const text = event.target.closest('.product-meta__rating--app .jdgm-prev-badge__text');
    if (!text) return;
    const stars = text.parentElement?.querySelector('.jdgm-prev-badge__stars');
    stars?.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
      this.section = this.closest('[data-product-section]');
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-value]')) this.onChange();
      });
    }

    selectedOptions() {
      return [...this.querySelectorAll('[data-option-index]')].map((group) => group.querySelector('[data-option-value]:checked')?.value);
    }

    onChange() {
      const options = this.selectedOptions();
      const variant = this.variants.find((candidate) => candidate.options.every((value, index) => value === options[index]));
      if (!variant) return;
      if (this.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      (this.section || document).dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant, source: this } }));
      this.refresh(variant);
    }

    async refresh(variant) {
      this.controller?.abort();
      this.controller = new AbortController();
      const url = `${this.dataset.productUrl}?variant=${variant.id}&section_id=${this.sectionId}`;
      try {
        const html = await (await fetch(url, { signal: this.controller.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-variant-swap]').forEach((fresh) => {
          const key = fresh.dataset.variantSwap;
          const current = (this.section || document).querySelector(`[data-variant-swap="${key}"]`);
          if (current) current.innerHTML = fresh.innerHTML;
        });
        (this.section || document).dispatchEvent(new CustomEvent('variant:rendered', { bubbles: true, detail: { variant } }));
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('variant-picker: refresh failed', error);
      }
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
